/**
 * Iconos en línea.
 *
 * Se dibujan como SVG con `currentColor` en lugar de cargar una fuente de iconos: evita una
 * petición bloqueante, hereda el color del tema sin reglas extra y no deja cuadros vacíos si la
 * red falla. Son decorativos, así que llevan `aria-hidden`.
 */
type IconProps = { size?: number; className?: string };

function svg(path: React.ReactNode, { size = 22, className }: IconProps) {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
    >
      {path}
    </svg>
  );
}

export const HomeIcon = (p: IconProps) =>
  svg(<><path d="M3 10.5 12 3l9 7.5" /><path d="M5 9.5V21h14V9.5" /></>, p);

export const SearchIcon = (p: IconProps) =>
  svg(<><circle cx="11" cy="11" r="7" /><path d="m20 20-3.5-3.5" /></>, p);

export const CalendarIcon = (p: IconProps) =>
  svg(
    <>
      <rect x="3" y="5" width="18" height="16" rx="2" />
      <path d="M3 10h18M8 3v4M16 3v4" />
    </>,
    p,
  );

export const ClockIcon = (p: IconProps) =>
  svg(<><circle cx="12" cy="12" r="9" /><path d="M12 7v5l3 2" /></>, p);

export const UsersIcon = (p: IconProps) =>
  svg(
    <>
      <circle cx="9" cy="8" r="3.2" />
      <path d="M3 20c0-3.2 2.7-5.2 6-5.2s6 2 6 5.2" />
      <path d="M16 5.2A3.2 3.2 0 0 1 16 11M17 14.2c2.4.5 4 2.3 4 5.8" />
    </>,
    p,
  );

export const PinIcon = (p: IconProps) =>
  svg(<><path d="M12 21s7-5.5 7-11a7 7 0 1 0-14 0c0 5.5 7 11 7 11Z" /><circle cx="12" cy="10" r="2.6" /></>, p);

export const StarIcon = (p: IconProps) =>
  svg(
    <path
      d="m12 3.6 2.6 5.3 5.8.8-4.2 4.1 1 5.8-5.2-2.7-5.2 2.7 1-5.8-4.2-4.1 5.8-.8Z"
      fill="currentColor"
      stroke="none"
    />,
    p,
  );

export const PhoneIcon = (p: IconProps) =>
  svg(
    <path d="M5 3h3.5l1.7 4.2-2.1 1.6a13 13 0 0 0 6.1 6.1l1.6-2.1L20 14.5V18a2 2 0 0 1-2.2 2A16.5 16.5 0 0 1 3 5.2 2 2 0 0 1 5 3Z" />,
    p,
  );

export const MenuIcon = (p: IconProps) =>
  svg(<><path d="M6 3h12v18H6z" /><path d="M9 8h6M9 12h6M9 16h4" /></>, p);

export const MapIcon = (p: IconProps) =>
  svg(<><path d="m3 6 6-2.5 6 2.5 6-2.5v15L15 21l-6-2.5L3 21Z" /><path d="M9 3.5v15M15 6v15" /></>, p);

export const BackIcon = (p: IconProps) =>
  svg(<><path d="M19 12H5" /><path d="m11 6-6 6 6 6" /></>, p);

export const CloseIcon = (p: IconProps) => svg(<><path d="M6 6 18 18M18 6 6 18" /></>, p);

export const CheckIcon = (p: IconProps) => svg(<path d="m5 12.5 4.5 4.5L19 7" />, p);

export const AlertIcon = (p: IconProps) =>
  svg(<><circle cx="12" cy="12" r="9" /><path d="M12 7.5v5.5M12 16.2v.1" /></>, p);

export const NoteIcon = (p: IconProps) =>
  svg(
    <>
      <rect x="4" y="3" width="16" height="18" rx="2" />
      <path d="M8 8h8M8 12h8M8 16h5" />
    </>,
    p,
  );

export const UserIcon = (p: IconProps) =>
  svg(<><circle cx="12" cy="8" r="3.6" /><path d="M4.5 20c0-3.8 3.3-6.2 7.5-6.2s7.5 2.4 7.5 6.2" /></>, p);

export const FilterIcon = (p: IconProps) =>
  svg(<><path d="M3 6h18M6 12h12M10 18h4" /></>, p);

export const ShareIcon = (p: IconProps) =>
  svg(
    <>
      <circle cx="18" cy="5.5" r="2.5" />
      <circle cx="6" cy="12" r="2.5" />
      <circle cx="18" cy="18.5" r="2.5" />
      <path d="m8.2 10.8 7.6-4M8.2 13.2l7.6 4" />
    </>,
    p,
  );
